import React, { forwardRef } from 'react';
import { FieldError } from 'react-hook-form/dist/types';
import classNames from 'classnames';

import './style.scss';

interface BaseSelectProps {
  options: any[];
  name: string;
  invalid?: FieldError;
  ref?: React.Ref<HTMLSelectElement>;
}

/** Base select component. */
const BaseSelect: React.FC<BaseSelectProps> = forwardRef((props, ref) => {
  const { options, name, invalid } = props;

  const selectClassName = classNames('form-control has-placeholder', { invalid });

  const renderOptions = options.map((option, index: number) => {
    const { value, disabled, label } = option;

    return (
      <option key={index} value={value} disabled={disabled}>
        {label}
      </option>
    );
  });

  return (
    <div className="form-group">
      <select className={selectClassName} defaultValue="" name={name} ref={ref} {...props}>
        {renderOptions}
      </select>
    </div>
  );
});

BaseSelect.displayName = 'BaseSelect';

export default BaseSelect;
